import { REDO_ONBOARDING_APP_URL } from "@redotech/redo-merchant-app-common/config";

// First-install onboarding now lives in welcome/welcome-page.tsx, entered via
// onboarding/first-install-redirect-guard.tsx. This module keeps only the URL builder.

/** Builds an onboarding-app URL with the merchant auth handoff in query params. */
export function autoOnboardingUrl(token: string, teamId: string) {
  const url = new URL(REDO_ONBOARDING_APP_URL);
  url.searchParams.set("token", token);
  url.searchParams.set("teamId", teamId);
  return url;
}
